import * as React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ContextMenuItem, ContextMenu, Flex, IconButton, Spacer, Switch } from '@siteground/styleguide';

import { toggleChatSound, toggleChatTranslate } from '../../actions';
import {
  chatClosedByClient,
  closeChatUIWindow,
  setChatMinimized
} from '../../app-communication/actions/from-client-frontend';
import { ROUTES } from '../../constants/routes';
import { getChatSettings, getIsChatMessagingInProgress } from '../../selectors/chat';
import { shouldShowTranslateButton } from '../../selectors/messages';
import './chat-layout.scss';

const ChatHeaderActions = (props) => {
  const { enableActionMenu, setConfirmChatClose, ...otherProps } = props;
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();

  const clearNoDragStyles = () => {
    //The draggable firing dragStart event but not the dragEnd so some styles staying in the dom
    document.body.style.userSelect = '';
    document.body.style.touchAction = '';
  };

  const { minimized, isChatWindowClosable } = useSelector(getChatSettings);
  const isChatMessagingInProgress = useSelector(getIsChatMessagingInProgress);
  const { sound, translate } = useSelector(getChatSettings);
  const shouldShowTranslate = useSelector(shouldShowTranslateButton);
  return (
    <Flex wrap="nowrap" {...otherProps}>
      {enableActionMenu && (
        <ContextMenu
          opener={<IconButton color="secondary" className="chat__header-button" icon="material/more_vert" />}
          priority="left"
        >
          <ContextMenuItem
            icon="sound"
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();

              dispatch(toggleChatSound({ isSoundOn: !sound }));
            }}
          >
            <Flex align="center" justify="space-between" wrap="nowrap">
              <div>
                {intl.formatMessage({ id: 'translate.chat.menu.sound.label' })}
                <Spacer size="xx-small" />
              </div>

              <Switch size="small" checked={sound} />
            </Flex>
          </ContextMenuItem>

          <ContextMenuItem icon="material/person" onClick={() => history.push(ROUTES.OPERATOR_INFO)}>
            {intl.formatMessage({ id: 'translate.chat.menu.operator.profile.label' })}
          </ContextMenuItem>

          {shouldShowTranslate && (
            <ContextMenuItem
              icon="ai_translate"
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();

                dispatch(toggleChatTranslate(!translate));
              }}
            >
              <Flex align="center" justify="space-between" wrap="nowrap">
                <div>
                  {intl.formatMessage({ id: 'translate.chat.menu.translate.label' })}
                  <Spacer size="xx-small" />
                </div>

                <Switch size="small" checked={translate} />
              </Flex>
            </ContextMenuItem>
          )}
        </ContextMenu>
      )}

      <div>
        <IconButton
          className="chat__header-button"
          icon="minus"
          color="secondary"
          type="ghost"
          onClick={() => {
            clearNoDragStyles();
            dispatch(setChatMinimized(!minimized));
          }}
        />
      </div>

      {isChatWindowClosable && (
        <div>
          <IconButton
            className="chat__header-button"
            icon="material/close"
            type="ghost"
            color="secondary"
            onClick={() => {
              if (isChatMessagingInProgress) {
                setConfirmChatClose(true);
                return;
              }
              clearNoDragStyles();
              dispatch(
                chatClosedByClient({
                  onFailure: () => dispatch(closeChatUIWindow())
                })
              );
            }}
          />
        </div>
      )}
    </Flex>
  );
};

ChatHeaderActions.defaultProps = {};

export default ChatHeaderActions;
